import { Typography } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import Tooltip from './BasicTooltip';
import Chart from '../../../../../../screens/Modules/pme/screens/dashboard/widgets/sdgs/chart';

const { Paragraph } = Typography;


const _config = [
  {
    color: '#F2F4F7',
    label: 'Not Assessed',
  },
  {
    color: '#B42318',
    label: 'Very High Risk',
  },
  {
    color: '#CC4426',
    label: 'High Risk',
  },
  {
    color: '#F38744',
    label: 'Medium Risk',
  },
  {
    color: '#FAC515',
    label: 'Low Risk',
  },
  {
    color: '#86CB3C',
    label: 'Very Low Risk',
  },
];

const MineSiteValidation = ({ data = {}, loading = true }) => {
  const { t } = useTranslation();

  const _total = useMemo(() => Object.values(data?.score || {}).reduce((all, val) => (all || 0) + (val || 0), 0), [data]);

  const items = useMemo(() => {
    if (data && data.score) {
      return _config.map((c, i) => ({
        ...c,
        percent: ((data.score[i] || 0) / _total),
        score: data.score[i],
      }))
    }

    return [];
  }, [data, _total]);

  const isEmpty = useMemo(() => !items.filter((it) => it.percent).length, [items]);

  const _renderTooltip = ({ mouseX, mouseY, item }) => {
    const label = t(item?.label);
    const value = `${item.score}/${_total}`;

    return (
      <Tooltip
        mouseY={mouseY}
        mouseX={mouseX}
        label={label}
        value={value}
        color={item?.color}
        type="RISK"
        isEmpty={isEmpty}
        t={t}
      />
    )
  }

  return (
    <div className="cont">
      <div className="h4-cont">
        <Paragraph className="h4" ellipsis={{ rows: 2, tooltip: t('Mine Site Validation') }}>
          {t('Mine Site Validation')}
        </Paragraph>
      </div>
      <div className="chart-cont">
        {loading && <WidgetLoader background="white" />}
        <Chart
          data={items}
          t={t}
          withBody={false}
          isEmpty={isEmpty}
          className="small-chart"
          renderTooltip={_renderTooltip}
        >
        </Chart>
      </div>
      <div className="p-cont">
        <p>
          {t('Status of mine sites included in the supply chain')}
        </p>
      </div>
    </div>
  );
};

export default MineSiteValidation;
